export default __webpack_public_path__ + "static/media/xbox_background.9d39a45d.jpg";